export default "__VITE_ASSET__D0Ms0Z5L__"